module.exports = __webpack_public_path__ + "img/1d-h17.e032c8fa.gif";